import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { propsRegisterData, propsRegisterState } from './interfaces';

const initialState: propsRegisterState = {
  data: {},
  step: 0,
  loading: false,
  success: false,
  error: false,
};

const registerSlice = createSlice({
  name: 'register',
  initialState,
  reducers: {
    registerRequest: (state) => {
      state.loading = true;
      state.error = false;
    },
    registerSuccess: (state) => {
      state.loading = false;
      state.success = true;
    },
    registerFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    registerSetData: (state, action: PayloadAction<Partial<propsRegisterData>>) => {
      state.data = { ...state.data, ...action.payload };
    },
    registerSetStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    clearRegister: () => initialState,
  },
});

export const {
  registerRequest,
  registerSuccess,
  registerFailure,
  registerSetData,
  registerSetStep,
  clearRegister,
} = registerSlice.actions;
export default registerSlice.reducer;
